import { render } from "storyblok-rich-text-react-renderer";
import TitleWithDescription from "./TitleWithDescription";

const TitleWithDescriptionWithProps = ({ blok }) => {
  return <TitleWithDescription sectionTitle={blok.sectionTitle} theme={blok.theme} />;
};

export default TitleWithDescriptionWithProps;
